import { render, staticRenderFns } from "./bulma_pivot.vue?vue&type=template&id=6e599fb5&lang=html"
import script from "./bulma_pivot.vue?vue&type=script&lang=js"
export * from "./bulma_pivot.vue?vue&type=script&lang=js"
import style0 from "./bulma_pivot.vue?vue&type=style&index=0&id=6e599fb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports